import {useState} from "react";
import ExerciseApiService from "../services/exercise-api.service";
import {useLoading} from "./use-loading.hook";
import {LoadingKeys} from "../models/enums/loading-keys.enum";
import {ExerciseDetails} from "../models/interfaces/exercise-details.interface";
import {ExerciseSearchResponseDto} from "../models/interfaces/exercise-search-response-dto.interface";

export const useExerciseApi = () => {
    const loadingKey = LoadingKeys.USE_EXERCISE_API;
    const {startLoading, stopLoading} = useLoading();
    const [error, setError] = useState<string | null>(null);

    const getExercise = async (id: string): Promise<ExerciseDetails> => {
        startLoading([loadingKey, "getExercise"]);
        setError(null);
        try {
            return await ExerciseApiService.getExerciseById(id);
        } catch (err: any) {
            setError(err.message);
            throw err;
        } finally {
            stopLoading([loadingKey, "getExercise"]);
        }
    };

    const searchExercises = async (filter: string = "", limit: number = 20, offset: number = 0): Promise<ExerciseSearchResponseDto> => {
        startLoading([loadingKey, "searchExercises"]);
        setError(null);
        try {
            return await ExerciseApiService.searchExercises(filter, limit, offset);
        } catch (err: any) {
            setError(err.message);
            throw err;
        } finally {
            stopLoading([loadingKey, "searchExercises"]);
        }
    };

    return {
        error,
        setError,
        getExercise,
        searchExercises,
    };
};

